import { lazyLoad } from 'utils/loadable';

export const PartnerDashboard = lazyLoad(
  () => import('./index'),
  module => module.PartnerDashboard,
);
